import axios from "axios";
import { API_URL } from "../../const";

/*************** PRODUCT DETAILS ADD START *************** */
export const productDetailsAdd = (addData: any) => {
  const data = {
    CreateProductToken: addData,
  };
  const url = `${API_URL}CreateProduct`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** PRODUCT DETAILS ADD END *************** */

/*************** PRODUCT DETAILS UPDATE START *************** */
export const productDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateProductDetailsToken: updateData,
  };
  const url = `${API_URL}UpdateProduct`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** PRODUCT DETAILS UPDATE END *************** */

/*************** PRODUCT DETAILS GET START *************** */
export const productListGet = (listData: any) => {
  const data = {
    GetAllProductPaginationToken: listData,
  };
  const url = `${API_URL}GetAllProductDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** PRODUCT DETAILS GET END *************** */

/*************** PRODUCT DETAILS FETCH START *************** */
export const productDetailsFetch = (fetchData: any) => {
  const data = {
    FetchProductDetailsToken: fetchData,
  };
  const url = `${API_URL}FetchProductDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** PRODUCT DETAILS FETCH END *************** */

/*************** PRODUCT DETAILS DELETE START *************** */
export const productDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteProductToken: deleteData,
  };
  const url = `${API_URL}DeleteProduct`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** PRODUCT DETAILS DELETE END *************** */

/*************** SINGLE PRODUCT QUESTION DELETE START *************** */
export const productQuestionDelete = (deleteData: any) => {
  const data = {
    DeleteProductQuestionToken: deleteData,
  };
  const url = `${API_URL}DeleteProductQuestion`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** SINGLE PRODUCT QUESTION DELETE END *************** */
